import { Theme } from '@mui/material';

export const MuiButtonStyled = (theme: Theme) => {
    theme.components = {
        ...theme.components,
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 55,
                    textTransform: 'unset',
                },
                
            },
        },
    };
};
